import { ChartTimeSeriesLineTheme } from '@hcs/design-system';
import { DateStr } from '@hcs/types';
import { CerberusStatsFields } from '@hcs/types';

import { CerberusStatsListingStatsChart } from '../../components';
import { MACRO_INSIGHTS_FROM_DATE } from '../../constants';
import { useMsaListingStatsTimeSeries } from '../../hooks';
import { getIsRentalListingStatsField } from '../../utils';

interface MsaListingStatsLineChartProps {
  className?: string;
  msaId: string;
  fromDate?: DateStr;
  toDate?: DateStr;
  cerberusStatsField: CerberusStatsFields;
  theme?: Partial<ChartTimeSeriesLineTheme>;
  propertyType?: 'singleFamily' | 'condo';
  setPropertyType?: (propertyType: 'singleFamily' | 'condo') => void;
  showPropertyTypeWarning?: boolean;
}
export const MsaListingStatsChart = ({
  className,
  msaId,
  fromDate = MACRO_INSIGHTS_FROM_DATE,
  toDate,
  cerberusStatsField,
  theme,
  propertyType,
  setPropertyType,
  showPropertyTypeWarning,
}: MsaListingStatsLineChartProps) => {
  const dataHcName = `msa-${cerberusStatsField}-chart`;
  const { data, isLoading } = useMsaListingStatsTimeSeries({
    msaId,
    fromDate,
    toDate,
    propertyType: propertyType === 'condo' ? 'condo' : 'singleFamily',
  });
  const isRentalField = getIsRentalListingStatsField(cerberusStatsField);

  return (
    <CerberusStatsListingStatsChart
      dataHcName={dataHcName}
      className={className}
      theme={theme}
      cerberusStatsField={cerberusStatsField}
      isRentalField={isRentalField}
      isLoading={isLoading}
      data={isRentalField ? data?.rentalListingStats : data?.saleListingStats}
      propertyType={propertyType ?? 'singleFamily'}
      setPropertyType={setPropertyType}
      showPropertyTypeWarning={showPropertyTypeWarning}
    />
  );
};
